import { render } from "./MappingSettings.vue?vue&type=template&id=a494d17a&scoped=true"
import script from "./MappingSettings.vue?vue&type=script&lang=js"
export * from "./MappingSettings.vue?vue&type=script&lang=js"

import "./MappingSettings.vue?vue&type=style&index=0&id=a494d17a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a494d17a"]])

export default __exports__